<template>
  <div
    :class="{
      modalAtivoNaoEncontrado: !dark,
      'modalAtivoNaoEncontrado-dark': dark,
    }"
  >
    <sweet-modal
      class="modalForm"
      ref="modalAtivoNaoEncontrado"
      title="Envie uma sugestão ou dúvida"
      blocking
      hide-close-button
      :overlayTheme="theme"
      :modalTheme="theme"
    >
      <form
        action="#"
        @submit.prevent="submitFormAtivo"
        data-vv-scope="formulario"
      >
        <div class="form-group mb-3">
          <!-- Tipo de Investimento -->
          <label for="email">E-mail</label>
          <input
            type="email"
            v-model="formularioAtivo.email"
            placeholder="Insira seu e-mail"
            v-validate="'email'"
            class="form-control"
            :class="{ 'is-invalid': errors.has('formulario.email') }"
            name="email"
            autocomplete="off"
          />
        </div>
        <div class="form-group mb-3">
          <!-- Tipo de Investimento -->
          <label for="mensagem">Mensagem</label>
          <textarea
            v-model="formularioAtivo.mensagem"
            placeholder="Insira seu comentário"
            v-validate="'required'"
            class="form-control"
            :class="{ 'is-invalid': errors.has('formulario.mensagem') }"
            name="mensagem"
            autocomplete="off"
          />
        </div>
        <div class="d-flex flex-row justify-content-between mt-4">
          <button
            class="btn btn-custom tertiary text-custom secondary"
            type="button"
            @click="$refs.modalAtivoNaoEncontrado.close()"
          >
            Cancelar
          </button>
          <button
            class="btn btn-custom success"
            type="submit"
            :disabled="!formValid"
          >
            Enviar
          </button>
        </div>
      </form>
    </sweet-modal>

    <sweet-modal
      class="modalMensagem"
      ref="modalMensagemEnviada"
      title="Mensagem enviada com sucesso"
      blocking
      hide-close-button
      :overlayTheme="theme"
      :modalTheme="theme"
    >
      <p>
        Em breve entraremos em contato com você para sanar todas as suas
        dúvidas.
      </p>
      <div class="d-flex flex-column mt-4">
        <button
          class="btn btn-custom tertiary text-custom secondary"
          type="button"
          @click="$refs.modalMensagemEnviada.close()"
        >
          Fechar janela
        </button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import Vue from "vue";
import ComparadorService from "@/app/services/Comparador/comparador.service";
import SpinnerService from "@/app/services/spinner.service";

export default {
  computed: {
    formValid() {
      return (
        this.errors.items.length === 0 &&
        this.formularioAtivo.email &&
        this.formularioAtivo.mensagem
      );
    },
    dark() {
      return this.$route.query.dark;
    },
    theme() {
      if (this.dark) {
        return "dark";
      } else {
        return "light";
      }
    },
  },
  data() {
    return {
      formularioAtivo: {
        email: "",
        mensagem: "",
      },
    };
  },
  methods: {
    abrir() {
      this.formularioAtivo.email = null;
      this.formularioAtivo.mensagem = null;

      // Resetar veevalidate
      this.$nextTick(() => {
        this.errors.clear();
        this.$nextTick(() => {
          this.$validator.reset();
        });
      });

      this.$refs["modalAtivoNaoEncontrado"].open();
    },
    submitFormAtivo(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.$refs.modalAtivoNaoEncontrado.close();
          SpinnerService.show();

          ComparadorService.enviarEmail({
            email: this.formularioAtivo.email,
            mensagem: this.formularioAtivo.mensagem,
          }).then((resposta) => {
            SpinnerService.hide();

            if (resposta.sucesso) {
              this.$refs.modalMensagemEnviada.open();
            } else {
              Vue.notify({
                title: "Erro",
                type: "error",
                group: "principal",
                text: resposta.mensagem,
                duration: 5000,
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.modalAtivoNaoEncontrado {
  .modalForm .sweet-modal {
    max-width: 450px;

    textarea {
      min-height: 150px;
      border-radius: 8px;
      border: 1px solid #bdbdbd;
    }

    textarea:focus {
      outline: none;
      border: 2px solid $main-color;
    }
  }

  .modalMensagem .sweet-modal {
    max-width: 440px;
  }
}

.modalAtivoNaoEncontrado-dark {
  .modalForm .sweet-modal {
    max-width: 450px;

    h2 {
      color: $text-font-color;
    }

    label {
      color: $text-font-color;
    }

    input {
      color: $text-font-color;
      background-color: $default-bg;
    }

    textarea {
      min-height: 150px;
      border-radius: 8px;
      border: 1px solid $main-color;
      color: $text-font-color;
      background-color: $default-bg;
    }

    textarea:focus {
      outline: none;
      border: 2px solid $main-color;
    }

    .btn-custom {
      color: $text-font-color;
      background-color: $main-color;
    }

    .btn-custom:hover {
      color: $text-font-color;
    }
  }

  .modalMensagem .sweet-modal {
    max-width: 440px;

    h2 {
      color: $text-font-color;
    }

    label {
      color: $text-font-color;
    }

    .btn-custom:hover {
      color: $text-font-color;
    }
  }
}
</style>